// this file was auto-generated by yo breck:model

export enum EducationCompletedTypes {
    EigthGradeOrAbove = 10,
    SomeHighSchool = 1,
    HighSchoolDiplomaGED = 2,
    TradeSchoolCertification = 3,
    SomeSchoolUniversity = 4,
    AssociatesDegree = 5,
    BachelorsDegree = 6,
    SomePostgraduate = 7,
    Masters = 8,
    PhD = 9,
}
